<app-dialog-banner text="AI answer for request {{ sr?.refNr }}" [dialogRef]="dialogRef"></app-dialog-banner>

<mat-dialog-content class="mat-typography" [attr.data-form-ready]="ready ? 'true' : null">

    <section class="theRequest">
        <h4>{{ sr?.title }}</h4>
        <div class="description">{{ sr?.description }}</div>
    </section>

    @if (canSend) {
        <p class="preamble" i18n>
            Our AI assistant read the request and suggests the following. Change anything you disagree
            with - what you send is what the person who raised it will see.
        </p>
    } @else {
        <p class="preamble" i18n>
            Our AI assistant read the request and suggests how to classify it.
        </p>
    }

    @if (canSend) {
        <app-field-set [fieldSet]="fieldSet" [isPhone]="isPhone" [initComplete]="ready"></app-field-set>
    } @else {
        <div class="classifyOnly">
            <app-field-set class="classification" [fieldSet]="fieldSet" [isPhone]="isPhone"
                [initComplete]="ready"></app-field-set>
            <aside class="cannotSend">
                <h4 i18n>No reply can be sent</h4>
                <p i18n>
                    Nobody outside your team follows this request, so there is no one to send a reply
                    to. If someone should hear back, choose Decide Later, add them as a follower, then
                    open the request again.
                </p>
                @if (log?.commentHtml) {
                    <div class="unsentLabel" i18n>The reply the assistant drafted, for reference:</div>
                    <div class="unsentReply" [innerHTML]="log.commentHtml"></div>
                }
            </aside>
        </div>
    }

</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (!fieldSet.formGroup?.valid) {
        <button mat-raised-button i18n (click)="highlightErrors()">Show Errors</button>
    }
    <button mat-raised-button [disabled]="saving" (click)="reject()" i18n>Reject</button>
    <button mat-raised-button mat-dialog-close i18n>Decide Later</button>
    @if (canSend) {
        <button mat-raised-button [disabled]="saving || !classificationValid" (click)="saveWithoutSending()"
            i18n>Save Without Sending</button>
        <button mat-raised-button color="primary" cdkFocusInitial data-save-button
            [disabled]="saving || !fieldSet.formGroup?.valid" (click)="send()" i18n>Send Reply</button>
    } @else {
        <button mat-raised-button color="primary" cdkFocusInitial data-save-button
            [disabled]="saving || !classificationValid" (click)="saveWithoutSending()" i18n>Save</button>
    }
</mat-dialog-actions>
